<template>
  <validated-form
    ref="form"
    auto-focus
    form-id="orderProviderStoreServiceConfigurationForm"
    @valid-submit="handleSubmit"
  >
    <modal-card :title="orderProviderServiceDescription">
      <div class="is-grid col-2 gap-x-lg gap-y">
        <validated-text-input
          v-model="form.orderProviderLocationId"
          name="orderProviderLocationId"
          label="Provider Location ID"
          type="text"
          rules="required"
        />
        <validated-text-input
          v-model="form.orderProviderMenuId"
          name="orderProviderMenuId"
          label="Provider Menu ID"
          type="text"
          rules="required"
        />
        <validated-text-input
          v-model="form.salesTaxRate"
          name="salesTaxRate"
          label="Sales Tax Rate"
          type="float"
        />
        <validated-text-input
          v-model="form.alcoholSalesTaxRate"
          name="alcoholSalesTaxRate"
          label="Alcohol Sales Tax Rate"
          type="float"
        />
      </div>
      <template #footer>
        <div class="buttons all-bold">
          <b-button
            rounded
            @click="$_confirmCloseModal({ programmatic: true })"
          >
            Cancel
          </b-button>
          <b-button
            v-tabbable
            rounded
            native-type="submit"
            type="is-primary"
            :loading="isSubmitting"
            :disabled="isSubmitting"
          >
            Save
          </b-button>
        </div>
      </template>
    </modal-card>
  </validated-form>
</template>

<script>
  import confirmModalCloseMixin from '@/mixins/confirm-modal-close';

  import OrderProviderService from '@/store/classes/OrderProviderService';
  import OrderProviderStoreService from '@/store/classes/OrderProviderStoreService';

  export default {
    name: 'OrderProviderServiceConfigurationModal',

    mixins: [confirmModalCloseMixin],

    props: {
      orderProviderStoreService: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        form: {}
      };
    },

    computed: {
      orderProviderServiceDescription() {
        return OrderProviderService.find(this.orderProviderStoreService.orderProviderServiceId)?.description;
      },

      isSubmitting() {
        return OrderProviderStoreService.$state().updating;
      }
    },

    created() {
      this.setForm();
    },

    methods: {
      setForm() {
        this.form = this.$clone(this.orderProviderStoreService);
      },

      async handleSubmit() {
        try {
          await OrderProviderStoreService.updateStoreService(this.form);

          this.$_onRequestSuccess({
            toastOptions: {
              message: `${this.orderProviderServiceDescription} successfully updated!`
            },
            options: {
              closeParent: true
            }
          });

          this.$emit('service-removed', this.orderProviderStoreService.id);
        }
        catch (error) {
          this.$_onRequestError({
            error,
            toastOptions: {
              message: `Unable to update ${this.orderProviderServiceDescription}`
            }
          });
        }
      }
    }
  };
</script>

<style lang="sass" scoped>
</style>
